import { useEffect, useState } from "react";
import { whatsappUrl } from "@/utils/whatsapp";
import { WA_MESSAGES, SANDO_NAV_LINKS, SANDO_LOGO } from "@/mocks/site";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [menuOpen]);

  return (
    <>
      <header
        className={`fixed inset-x-0 top-0 z-40 transition-colors duration-300 ${
          scrolled
            ? "bg-background-100/95 backdrop-blur-md border-b border-secondary-200/70"
            : "bg-transparent"
        }`}
      >
        <div className="flex h-[68px] md:h-[76px] w-full items-center justify-between px-4 md:px-10">
          <a href="#inicio" className="flex items-center gap-3" aria-label="Sando by Cerón — inicio">
            <img
              src={SANDO_LOGO}
              alt="Logotipo de Sando by Cerón"
              className={`h-9 w-auto transition-all md:h-11 ${scrolled ? "" : "brightness-0 invert"}`}
            />
          </a>

          <nav className="hidden items-center gap-9 md:flex" aria-label="Navegación principal">
            {SANDO_NAV_LINKS.map((link) => (
              <a
                key={link.id}
                href={link.href}
                className={`whitespace-nowrap text-sm font-medium tracking-wide transition-colors ${
                  scrolled
                    ? "text-foreground-800 hover:text-primary-500"
                    : "text-background-50 hover:text-primary-200"
                }`}
              >
                {link.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <a
              href={whatsappUrl(WA_MESSAGES.general)}
              target="_blank"
              rel="noopener noreferrer"
              className="hidden items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors duration-200 hover:bg-primary-600 md:inline-flex"
            >
              <i className="ri-whatsapp-line text-base" aria-hidden="true" />
              Pedir
            </a>
            <a
              href={whatsappUrl(WA_MESSAGES.general)}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50 md:hidden"
            >
              Pedir
            </a>
            <button
              type="button"
              onClick={() => setMenuOpen(true)}
              aria-label="Abrir menú"
              className={`inline-flex h-10 w-10 items-center justify-center rounded-md md:hidden ${
                scrolled ? "text-foreground-950" : "text-background-50"
              }`}
            >
              <i className="ri-menu-line text-2xl" aria-hidden="true" />
            </button>
          </div>
        </div>
      </header>

      <div
        className={`fixed inset-0 z-50 flex flex-col bg-background-50 transition-opacity duration-300 md:hidden ${
          menuOpen ? "pointer-events-auto opacity-100" : "pointer-events-none opacity-0"
        }`}
        aria-hidden={!menuOpen}
      >
        <div className="flex h-[68px] items-center justify-between px-4">
          <img src={SANDO_LOGO} alt="Logotipo de Sando by Cerón" className="h-9 w-auto" />
          <button
            type="button"
            onClick={() => setMenuOpen(false)}
            aria-label="Cerrar menú"
            className="inline-flex h-10 w-10 items-center justify-center rounded-md text-foreground-950"
          >
            <i className="ri-close-line text-2xl" aria-hidden="true" />
          </button>
        </div>
        <nav className="flex flex-1 flex-col items-center justify-center gap-7 px-6" aria-label="Navegación móvil">
          {SANDO_NAV_LINKS.map((link) => (
            <a
              key={link.id}
              href={link.href}
              onClick={() => setMenuOpen(false)}
              className="font-heading text-3xl text-foreground-950 transition-colors hover:text-primary-500"
            >
              {link.label}
            </a>
          ))}
          <a
            href={whatsappUrl(WA_MESSAGES.general)}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => setMenuOpen(false)}
            className="mt-4 inline-flex items-center gap-2 rounded-md bg-primary-500 px-8 py-3.5 text-base font-medium text-background-50"
          >
            <i className="ri-whatsapp-line text-lg" aria-hidden="true" />
            Pedir por WhatsApp
          </a>
        </nav>
      </div>
    </>
  );
}